import { Check } from 'lucide-react';
import { proofLevels } from '../data/proofLevels';
import { useI18n } from '../i18n/useI18n';

export function ProofLevelsSection() {
  const { t } = useI18n();

  return (
    <section className="section">
      <div className="section-heading">
        <p className="eyebrow">{t('levels.eyebrow')}</p>
        <h2>{t('levels.title')}</h2>
      </div>
      <div className="level-grid">
        {proofLevels.map((level) => (
          <article className="level-card" key={level.id}>
            <span>{t(level.labelKey)}</span>
            <h3>{t(level.titleKey)}</h3>
            <p>{t(level.textKey)}</p>
            <ul>
              {level.points.map((point) => (
                <li key={point}>
                  <Check size={17} />
                  {t(point)}
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </section>
  );
}
